import { render, staticRenderFns } from "./TaskAppNotesItem.vue?vue&type=template&id=7cb19a92&scoped=true&lang=pug&functional=true&"
import script from "./TaskAppNotesItem.vue?vue&type=script&lang=js&"
export * from "./TaskAppNotesItem.vue?vue&type=script&lang=js&"
import style0 from "./TaskAppNotesItem.vue?vue&type=style&index=0&id=7cb19a92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "7cb19a92",
  null
  
)

export default component.exports